package scenes.levels

import AppState
import scenes.*

class Level5Scene : BaseLevel(
    levelFile = "levels/level_5.tmx",
    levelWidth = 2560.0,
    levelHeight = 1280.0
) {
    override suspend fun changeToNextLevel() {
        val appState = injector.get<AppState>()
        appState.sceneToLoad = Level6Scene::class
        appState.nextLevel = 6
        sceneContainer.changeTo<SceneLoadingScene>()
    }
}
